var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeftUp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86667 6.86667C5.86667 6.31438 6.31438 5.86667 6.86667 5.86667L16.1281 5.86667C16.6804 5.86667 17.1281 6.31438 17.1281 6.86667C17.1281 7.41895 16.6804 7.86667 16.1281 7.86667L9.28088 7.86667L17.8404 16.4262C18.231 16.8168 18.231 17.4499 17.8404 17.8404C17.4499 18.231 16.8168 18.231 16.4262 17.8404L7.86667 9.28088L7.86667 16.1281C7.86667 16.6804 7.41895 17.1281 6.86667 17.1281C6.31438 17.1281 5.86667 16.6804 5.86667 16.1281L5.86667 6.86667Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeftUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowLeftUp.94f7385e4efe0b00548030b53d8ac470.svg";